<template>
  <v-dialog v-model="active"
            width="45%">
    <!-- inicio de evento de baja -->
    <v-stepper v-model="step">
      <v-progress-linear absolute
                         top
                         active
                         :value="(step) * 100 / 3"
                         height="8"
                         buffer-value="100">
      </v-progress-linear>

      <v-stepper-items class="std-text-md mt-8">
        <!-- inicio dialog 1 -->
        <v-stepper-content step="1">
          <v-row no-gutters class="mb-6">
            <v-col cols="12"
                   class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
              <div class="font-weight-bold col-12 pa-0 mb-4">Cambio de {{place}}</div>
              <div class="col-12 pa-0 mb-4">La vaca <b>{{id}}</b> será cambiada de:</div>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters class="justify-space-around">
                <v-col cols="5">
                  <v-hover v-slot:default="{ hover }">
                    <div class="col-12 std-border-radius d-flex align-center std-smart-check"
                         :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && alert.place !== 'pad'}"
                         @click="alert.place = 'pad'">
                      Rancho
                    </div>
                  </v-hover>
                </v-col>
                <v-col cols="5">
                  <v-hover v-slot:default="{ hover }">
                    <div class="col-12 std-border-radius d-flex align-center std-smart-check"
                         :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && alert.place !== 'gpr'}"
                         @click="alert.place = 'gpr'">
                      Grupo
                    </div>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters
                 justify="space-between">
            <v-col cols="3" @click="close()">
              <BackButton></BackButton>
            </v-col>
            <v-col cols="3"
                   @click="step++">
              <WarnButton text="Continuar"></WarnButton>
            </v-col>
          </v-row>
        </v-stepper-content>
        <!-- fin de dialog 1 -->

        <!-- inicio de dialog 2 -->
        <v-stepper-content step="2">
          <v-row no-gutters class="mb-6">
            <v-col cols="12"
                   class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
              <div class="font-weight-bold col-12 pa-0 mb-4">Cambio de {{place}}</div>
            </v-col>
            <v-col cols="12"
                   class="d-flex flex-wrap std-text-blue-2">
              <div class="col-12 pa-0 font-weight-bold text-capitalize">{{place}}</div>
              <v-select
                  v-if="alert.place === 'pad'"
                  v-model="alert.name"
                  :items="paddocks"
                  hide-details
                  hide-selected
                  dense
                  item-text="name"
                  return-object
                  outlined>
              </v-select>
              <v-select
                  v-else
                  v-model="alert.name"
                  :items="groups"
                  hide-details
                  hide-selected
                  dense
                  :placeholder="groups[0]"
                  outlined>
              </v-select>
            </v-col>
          </v-row>
          <v-row no-gutters
                 justify="space-between">
            <v-col cols="3" @click="backTwo()">
              <BackButton></BackButton>
            </v-col>
            <v-col cols="5"
                   @click="nextTwo()">
              <WarnButton text="Continuar"></WarnButton>
            </v-col>
          </v-row>
        </v-stepper-content>
        <!-- fin de dialog 2 -->

        <!-- inicio dialog 3 -->
        <v-stepper-content step="3">
          <v-row no-gutters class="mb-6">
            <v-col cols="12"
                   class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
              <div class="font-weight-bold col-12 pa-0 mb-4">Cambio de {{place}}</div>
              <div class="col-12 pa-0">La vaca <b>{{id}}</b> será cambiada al {{place}} <b>{{name}}</b></div>
            </v-col>
          </v-row>
          <v-row no-gutters
                 justify="space-between">
            <v-col cols="3" @click="backThree()">
              <BackButton></BackButton>
            </v-col>
            <v-col cols="3"
                   @click="storeChange()">
              <WarnButton text="Continuar"></WarnButton>
            </v-col>
          </v-row>
        </v-stepper-content>
        <!-- fin de dialog 3 -->


      </v-stepper-items>
    </v-stepper>
    <!-- fin de evento de baja -->
  </v-dialog>
</template>

<script>
import WarnButton from "@/components/WarnButton";
import BackButton from "@/components/BackButton";
import {EventBus} from "@/views/bus";
export default {
  name: "changeDialog",
  components: {BackButton, WarnButton},
  data: () => {
    return {
      active: false,
      animals: [],
      group: null,
      paddock: null,
      step: 1,
      key: null,
      animalType: 'cow',
      id: null,
      groups: ['Establo general', 'Alta producción', 'Secas o en reto', 'Recién paridas', 'Enfermas'], // grupos personalizados
      alert: {
        place: null,
        name: null,
      }
    }
  },
  watch: {
    active(val) {
      if (!val) {
        this.step = 1;
      }
    },
    alertPlace(val) {
      if (val === 'pad') {
        this.alert.name = this.paddock;
      } else {
        this.alert.name = this.group;
      }
    }
  },
  computed: {
    /**
     * Returns a lowercase version of the group or paddock
     */
    place() {
      return this.alert.place === 'pad' ? 'rancho' : 'grupo';
    },
    /**
     * Returns a lowercase version of the group or paddock selected to change
     */
    name() {
      if (this.alert.place === 'pad') {
        //return this.alert.name.name.toLowerCase()
      } else {
        //return this.alert.name.toLowerCase()
      }
      return ''
    },
    /**
     * Returns the paddocks from the store
     */
    paddocks() {
      return this.$store.getters.paddocks;
    },
    alertPlace() {
      return this.alert.place;
    }
  },
  methods: {
    close() {
      this.active = false;
    },
    backTwo() {
      this.step = 1;
      this.alert.place = 'pad';
    },
    nextTwo() {
      // shows a briefly notification
      if (!this.alert.name) {
        EventBus.$emit('errSnack', '¡Selecciona un ' + this.place + '!');
      } else {
        this.step++;
      }
    },
    backThree() {
      this.step = 2;
    },
    storeChange() {
      if (this.alert.place === 'pad') {
        this.$store.dispatch('changePaddock', {paddock: this.alert.name.name, key: this.key});
        EventBus.$emit('errSnack', {text: '¡Cambiando de rancho!', type: 'cgg'});
      } else {
        this.$store.dispatch('changeGroup', {group: this.alert.name, key: this.key});
        EventBus.$emit('errSnack', {text: '¡Cambiando de grupo!', type: 'cgg'});
      }
      this.active = false;
    }
  },
  mounted() {
    EventBus.$on('openChangeDlg', (info) => {
      this.key = info.key;
      this.id = info.id;
      this.animalType = info.animalType;
      this.active = true;
      this.animals = info.animals;
      this.paddock = this.$store.getters.paddock;
      info.animals.forEach(animal => {
        if (animal.key === info.key) {
          this.group = animal.group;
        }
      });
      this.alert.place = 'pad';
    });
  }
}
</script>

<style scoped>

</style>